// extracted by mini-css-extract-plugin
export default {"stars-container":"Rating_stars-container__NoMNb","star":"Rating_star__L7A-a"};